import { Modal } from "react-bootstrap";
import { Button } from "../../../components/button";
import { GenericForm } from "../../../components/generic-form";

import { CreateTaskModalProps } from "./CreateTaskModal.types";

const CreateTaskModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  createTaskForm,
}: CreateTaskModalProps) => {
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Create Task
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={createTaskForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={creating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                Create
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CreateTaskModal;
